import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? 'preprod',
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
    initialScope: { tags: { service: 'admin' } },
  });
} else {
  // eslint-disable-next-line no-console
  console.log('[sentry] disabled for admin (no VITE_SENTRY_DSN)');
}

export { Sentry };
